import netsHeaderCompact from './nets-header-compact';

export default angular
  .module('app.headerCompact', [])
  .component('netsHeaderCompact', netsHeaderCompact);
